
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.97 2.97a2.871 2.871 0 114.06 4.06l-1.498 1.5h-.002v.002l-7 6.998a.75.75 0 01-.53.22H9a.75.75 0 01-.75-.75v-3a.75.75 0 01.22-.53l7-7 1.5-1.5zM16 6.06l-6.25 6.25v1.94h1.94L17.94 8 16 6.06zm3 .88L17.06 5l.97-.97a1.371 1.371 0 011.94 1.94l-.97.97zm-14.945.115A2.75 2.75 0 016 6.25h3a.75.75 0 010 1.5H6A1.25 1.25 0 004.75 9v9A1.25 1.25 0 006 19.25h9A1.25 1.25 0 0016.25 18v-3a.75.75 0 011.5 0v3A2.75 2.75 0 0115 20.75H6A2.75 2.75 0 013.25 18V9c0-.73.29-1.429.805-1.945z"}})])
          )
        }
      }
    